import { QueryProjReq } from "@/model/request/proj/query/QueryProjReq";
import { getProjectList, moveProject } from "@/service/project/ProjectService";
import { ResponseHandler } from "rdjs-wheel";
import { useRef, useState } from "react";
import { toast } from 'react-toastify';
import { MoveProjReq } from "@/model/request/proj/edit/MoveProjReq";
import { TexProjectFolder } from "@/model/proj/TexProjectFolder";
import React from "react";
import { useTranslation } from "react-i18next";

export type MoveProps = {
    getProjFilter: (query: QueryProjReq) => QueryProjReq;
    currProject: any,
    currFolder: TexProjectFolder | undefined,
    folders: TexProjectFolder[],
    projType: number,
    rmFolder: (folderId: number) => void
};

const TeXMoveToFolder: React.FC<MoveProps> = (props: MoveProps) => {

    const editProjCancelRef = useRef<HTMLButtonElement>(null);
    const currProject = props.currProject;
    const [currSelectFolderId, setCurrSelectFolderId] = useState<number>(-1);
    const { t } = useTranslation();

    React.useEffect(() => {
        if (props.folders && props.folders.length > 0) {
            setCurrSelectFolderId(props.folders[0].id!);
        }
    }, []);

    const handleProjMove = () => {
        if (!currProject || !currProject.project_id) {
            toast.info(t("tips_choose_proj_move"));
            return;
        }
        let proj: MoveProjReq = {
            project_id: currProject?.project_id,
            folder_id: currSelectFolderId,
            proj_type: props.projType
        };
        moveProject(proj).then((resp) => {
            if (ResponseHandler.responseSuccess(resp)) {
                props.rmFolder(currSelectFolderId);
                getProjectList(props.getProjFilter({}));
                if (editProjCancelRef && editProjCancelRef.current) {
                    editProjCancelRef.current.click();
                }
            } else {
                toast.error(t("err_move_proj_failed", { msg: resp.msg }));
            }
        });
    }

    const renderSelected = () => {
        if (!props.folders || props.folders.length === 0) {
            return;
        }
        const tagList: React.JSX.Element[] = [];
        let folders = props.folders;
        for (let i = 0; i < folders.length; i++) {
            if (i === 0) {
                tagList.push(<option key={folders[i].id} value={folders[i].id}>{folders[i].folder_name}</option>);
            } else {
                tagList.push(<option key={folders[i].id} value={folders[i].id}>{folders[i].folder_name}</option>);
            }
        }
        return tagList;
    }

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let selectValue = e.target.value
        setCurrSelectFolderId(parseInt(selectValue));
    };

    return (
        <div>
            <div className="modal" id="moveProj" tabIndex={-1}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("btn_move_to_folder")}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <select className="form-select"
                                defaultValue={(props.folders && props.folders.length > 0) ? props.folders[0].id : -1}
                                onChange={handleSelectChange}
                                aria-label="Default select example">
                                {renderSelected()}
                            </select>
                        </div>
                        <div className="modal-footer">
                            <button type="button" ref={editProjCancelRef} className="btn btn-secondary" data-bs-dismiss="modal">{t("btn_cancel")}</button>
                            <button type="button" className="btn btn-primary" onClick={() => { handleProjMove() }}>{t("btn_confirm")}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TeXMoveToFolder;